import { useTranslation } from 'react-i18next'

import { webApp } from '@shared'

import { useFeedback } from '../Feedback'

function execCommandCopy(text: string): boolean {
  try {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.setAttribute('readonly', '')
    ta.style.position = 'fixed'
    ta.style.left = '-9999px'
    ta.style.top = '0'
    ta.style.opacity = '0'

    document.body.appendChild(ta)

    ta.focus()
    ta.select()

    const ok = document.execCommand('copy')
    document.body.removeChild(ta)

    return ok
  } catch {
    return false
  }
}

export function useClipboard() {
  const { showToast } = useFeedback()
  const { t } = useTranslation()

  return {
    copy: (text: string, message: string) => {
      navigator.clipboard.writeText(text.toString())
        .then(() => {
          showToast({ message, type: 'copy', time: 2000 })
        })
        .catch((err) => {
          const ok = execCommandCopy(text.toString())
          if (ok) {
            showToast({ message, type: 'copy', time: 2000 })
            return
          }

          showToast({ type: 'error', message: t('ds.useClipboard.error') })
        })

      webApp.HapticFeedback.notificationOccurred('success')
    },
  }
}